import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Shield, X } from "lucide-react";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem("cookie_consent", "refused");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur-xl border-t border-white/10 p-4 md:p-6 animate-fade-in"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center gap-4">
        <Shield className="w-5 h-5 text-blue-400 shrink-0 mt-0.5 md:mt-0" />
        <div className="flex-1">
          <p className="font-body text-sm text-slate-300">
            Ce site utilise uniquement des <strong className="text-slate-50">cookies techniques</strong> n{"\u00e9"}cessaires
            au fonctionnement du backoffice. Aucun cookie publicitaire n'est utilis{"\u00e9"}.{" "}
            <Link to="/confidentialite" className="text-blue-400 hover:text-blue-300 underline">
              Politique de confidentialit{"\u00e9"}
            </Link>
          </p>
        </div>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={refuse}
            data-testid="cookie-refuse"
            className="font-body text-sm text-slate-400 hover:text-slate-50 px-4 py-2 rounded-full border border-white/10 hover:border-white/30 transition-all"
          >
            Refuser
          </button>
          <button
            onClick={accept}
            data-testid="cookie-accept"
            className="font-body text-sm text-white bg-blue-500 hover:bg-blue-400 px-5 py-2 rounded-full font-medium transition-all"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
}
